/**
 * Convert any image/file from a URL into Base64 string
 * @param url Path or URL of the file (e.g. '/logo.png')
 * @returns Promise<string> Base64 string
 */
export async function getBase64FromUrl(url: string): Promise<string> {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
}
